import { render, staticRenderFns } from "./DialogDetallesOdt.vue?vue&type=template&id=2ff6b26a&scoped=true&"
import script from "./DialogDetallesOdt.vue?vue&type=script&lang=js&"
export * from "./DialogDetallesOdt.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetallesOdt.vue?vue&type=style&index=0&id=2ff6b26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6b26a",
  null
  
)

export default component.exports